// src/features/executive/sales/usedStyle.tsx
import { Box, styled } from '@mui/material'

export const TabRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),  // larger gap between sections vs within sections
}))

// Section = header + one or more rows.
export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))

// 2-col row for Top Performers (procedures + doctors) and Mix (category + payment).
export const Row = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
}))

// Hero row of 4 KPI tiles — SalesSummaryTiles renders 4 KPICards directly.
export const HeroRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(4, 1fr)' },
}))
